import {FORM} from '../../../../../../js/constants/form-types';
import Button from '../../../../../ui/button/Button';

export default function editDemandsForm(handleMediaPicker) {
    return({
        titleForm: "Modifier une demande",
        subTitleForm: 'Veuillez compléter les champs ci-dessous pour configurer une demande',
        langSelect: false,
        drawerType: 'drawer',
        noForm: true,
        component: Button,
        textButtonValidate: 'Modifier la demande',
        formConfig: {
            type: FORM,
            finalStep:{},
            children:[
                {
                    labelName: 'Identité',
                    optionsInputs:[
                        {
                            type: 'mediaPicker',
                            label: 'Image de la demande',
                            translated: false,
                            handleMediaPicker: handleMediaPicker,
                            helper:  {
                                text: 'Choisir une image',
                                link: false,
                            },
                            required: false,
                            stateName: 'image',
                        },
                        {
                            type: 'text',
                            label: 'Code',
                            helper: {
                                text: 'Indiquez le code ici',
                                link: false,
                            },
                            required: true,
                            stateName: 'code',
                        },
                        {
                            type: 'text',
                            label: 'Nom',
                            helper: {
                                text: 'Indiquez le nom ici',
                                link: false,
                            },
                            required: true,
                            stateName: 'name',
                        },
                    ]
                },
            ]
        }
    })
}

